import React from "react";
import TabRetailerApplication from "./TabRetailerApplication";

type Props = {};

const TabRetailerApplicationWrapper = (props: Props) => {
  return (
      <TabRetailerApplication />
  );
};

export default TabRetailerApplicationWrapper;
